import { useMemo } from "react";

/**
 * Calculate CIP metrics including defected CIPs, total CIPs, and defect rate
 * Excludes "Down Time" and "Break" from totals
 */
export function useCipMetrics(filteredData, cipTotalsData) {
  return useMemo(() => {
    // Calculate defected CIPs from all data (ignoring analysis filters)
    const uniqueDefectedCips = new Set(
      filteredData.map((row) => row.cip_object_id)
    );
    const defectedCipsCount = uniqueDefectedCips.size;

    // Filter out non-production objects (Down Time and Break) before counting total CIPs
    const filteredCipTotalsData = cipTotalsData
      ? cipTotalsData.filter(
          (item) =>
            item.objectName !== "Down Time" &&
            item.objectName !== "Break" &&
            item.objectName !== "Inactive" &&
            item.objectName !== "Communication Error"
        )
      : [];

    const totalCipsCount = filteredCipTotalsData.length;

    // Calculate defect rate as percentage of production CIPs that had alerts
    const defectRate =
      totalCipsCount > 0 ? (defectedCipsCount / totalCipsCount) * 100 : 0;

    return {
      defectedCips: defectedCipsCount,
      totalCips: totalCipsCount,
      defectRate,
    };
  }, [filteredData, cipTotalsData]);
}
